import {Injectable, Pipe, PipeTransform} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PersonalUserDataService } from '../services/personal-user-data/personal-user-data.service';
import { ChangeDetectorRef } from '@angular/core';
import { Gender } from '../enum/gender.enum';

@Pipe({
  name: 'gender'
})


@Injectable({
  providedIn: 'root'
})
export class GenderPipe implements PipeTransform {
  constructor(public personalUserDataService: PersonalUserDataService) { }
  transform(value: any): any {
    const gender = Gender[this.personalUserDataService.getLoggedInUserGender()];
    return value +'.'+ gender;
  }

}